import {mfaHeld} from '~/utils/mfa';
import {useAuthService} from "~/composables/useAuthService";
import {useUserFormPrompts} from "~/composables/useUserFormPrompts";

/**
 * A REQUIRED set of server-authored forms holds the site until it is answered
 * (USER_FORM_PROMPTS_PLAN.md). Runs after accountSetup (alphabetical), so an
 * account created without the terms and a date of birth gives those first. A
 * missing name is this wall's to ask: the sign-up set carries it as a required
 * question.
 *
 * THE BLOCKING IS THE ROUTE, and that is the point. This runs on every
 * navigation, so there is no state in which somebody is past it. Drawing the
 * wall as a modal over the current page instead would make the guarantee depend
 * on a component mounting — a render error, a stray v-if or a slow hydrate and
 * the member is through a wall that is not there. The card they see at /prompt
 * is a presentation change; this is not.
 *
 * Never a trap: the exits stay reachable — the legal pages the form links to,
 * the profile page (delete account / export), contact, the email one-click
 * pages that must never be hijacked, and the super admin console, which is the
 * only place a set can be withdrawn. Log out is a button on the form itself.
 *
 * An OPTIONAL set is NOT routed here any more. It is offered by a small docked
 * card (PromptIntroDock) over a page that still works, and putting it off is a
 * real snooze recorded on the server rather than a sessionStorage flag that
 * forgot every time somebody opened a new tab.
 */
const {promptWallDestination} = useUserFormPrompts();

export default defineNuxtRouteMiddleware((to) => {
    const {isAuthenticated, user} = useAuthService();
    if (!isAuthenticated.value) return;
    // The two-step wall goes first and alone (utils/mfa.js mfaHeld).
    if (mfaHeld(user.value)) return;

    // The exits and the decision are a pure function so they can be tested. The
    // list of routes a wall must not hold is the whole of the escape hatch, and
    // a constant sitting in a middleware nobody can call is a list nobody can
    // check. See promptWallDestination.
    const destination = promptWallDestination(to.fullPath, user.value?.pendingFormPrompt);
    if (destination) return navigateTo(destination);
});
